import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo, useCallback } from 'react';
import { bool } from 'prop-types';
import Slider from 'react-slick';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { PrevIcon, NextIcon, Button, ProductSliderItem } from '../../../../components';
import classes from './productListSlider.module.css';
import { Link } from 'react-router-dom';

var ProductListSlider = function ProductListSlider(props) {
  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;
  var products = props.products,
      _props$title = props.title,
      title = _props$title === void 0 ? 'You May Also Like' : _props$title,
      isCollection = props.isCollection,
      collectionUrlKey = props.collectionUrlKey;
  var CustomPrevArrow = useCallback(function (props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick;
    return React.createElement("div", {
      className: className,
      style: style,
      onClick: onClick
    }, React.createElement(PrevIcon, null));
  }, []);
  var CustomNextArrow = useCallback(function (props) {
    var className = props.className,
        style = props.style,
        onClick = props.onClick;
    return React.createElement("div", {
      className: className,
      style: style,
      onClick: onClick
    }, React.createElement(NextIcon, null));
  }, []);
  var settings = useMemo(function () {
    return {
      dots: false,
      speed: 500,
      infinite: true,
      // autoplay: true,
      arrows: true,
      slidesToShow: isCollection ? 3 : 4,
      slidesToScroll: 1,
      nextArrow: React.createElement(CustomNextArrow, null),
      prevArrow: React.createElement(CustomPrevArrow, null),
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // arrows: false,
          dots: true
        }
      }]
    };
  }, []);
  var productItems = useMemo(function () {
    return products.map(function (product, idx) {
      return React.createElement(ProductSliderItem, {
        key: idx,
        item: product
      });
    });
  }, [products]);
  var sliderContent = useMemo(function () {
    return React.createElement(React.Fragment, null, products.length <= 3 && !isSmallDevice ? React.createElement("div", {
      className: "grid grid-cols-3 ml-5 h-full gap-x-3 md_gap-x-5"
    }, products.map(function (item, idx) {
      return React.createElement("div", {
        className: "col-span-1",
        key: 'div-' + idx
      }, React.createElement(ProductSliderItem, {
        key: idx,
        item: item
      }));
    })) : React.createElement(Slider, _extends({}, settings, {
      className: classes.sliderWrapper
    }), productItems));
  }, [products]);
  return React.createElement("div", {
    className: "mt-5"
  }, isCollection ? React.createElement("div", {
    className: "grid grid-cols-12"
  }, React.createElement("div", {
    className: "col-span-12 z-10 lg_col-span-3 bg-bronze mb-2.5 lg_mb-0"
  }, React.createElement("div", {
    className: "py-12 lg_py-32 2xl_py-44 md_pl-5 2xl_pl-12"
  }, React.createElement("h3", {
    className: "text-white mb-10 leading-139 text-center md_text-left font-bold"
  }, title), collectionUrlKey && React.createElement(Link, {
    to: collectionUrlKey,
    target: "_blank",
    className: classes.viewAll
  }, "VIEW ALL"))), React.createElement("div", {
    className: "col-span-12 lg_col-span-9"
  }, sliderContent)) : React.createElement(React.Fragment, null, React.createElement("h3", {
    className: "text-center uppercase text-black font-bold"
  }, title), React.createElement("div", {
    className: "md_my-12 my-20"
  }, sliderContent)));
};

export default ProductListSlider;
ProductListSlider.propType = {
  isCollection: bool
};
ProductListSlider.defaultProps = {
  isCollection: false
};